import { render, staticRenderFns } from "./CoinsPayment.vue?vue&type=template&id=10b2851d&scoped=true&"
import script from "./CoinsPayment.vue?vue&type=script&lang=js&"
export * from "./CoinsPayment.vue?vue&type=script&lang=js&"
import style0 from "./CoinsPayment.vue?vue&type=style&index=0&id=10b2851d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b2851d",
  null
  
)

export default component.exports